import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { styled } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

export const StyledCheckBoxIcon = styled(CheckBoxIcon)(
  ({ theme }: { theme: ICustomTheme }) => ({
    color: theme.colors.paletteFromBO.secondary,
  }),
);

export const StyledExpandMoreIcon = styled(ExpandMoreIcon)(() => ({
  width: 26,
  height: 26,
  right: 12,
  position: 'absolute',
  userSelect: 'none',
  pointerEvents: 'none',
}));
